import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { CustomLink } from '../../../../../common/CustomLink'
import { Icon } from '../../../../../common/html/icon'
import { Table } from '../../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../../routers/constants'
import { changePeerOrganizationIds } from '../../../store/slice'
import { CheckboxCellTable } from '../../CheckboxCellTable'
import { FA_COLORS } from '../../constants'
import { removeOwnershipAndGroup } from '../../ownershipAndGroup/store/slice'
import {
  changeSelectedCompanyList,
  selectSelectedCompanyList,
} from '../../search/popupRecommendationList/store/slice'
import {
  changeListChart,
  selectIsLoading,
  selectShowListChart,
  selectTableHeader,
  selectTableIds,
  selectTableItem,
} from '../store/slice'
import { ValueCell } from './ValueCell'

export const TableContent = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const [colors, setColors] = useState(FA_COLORS)

  const ids = useSelector(selectTableIds)
  const tableHeader = useSelector(selectTableHeader)
  const isLoading = useSelector(selectIsLoading)
  const selectedCompanyList = useSelector(selectSelectedCompanyList)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const onRemoveCompany = (rowId) => () => {
    const filteredCompany = selectedCompanyList.filter(
      (company) => company.id !== rowId,
    )
    const filteredCompanyListIds = filteredCompany.map((item) => item.id)
    dispatch(removeOwnershipAndGroup(rowId))
    dispatch(changeSelectedCompanyList(filteredCompany))
    dispatch(changePeerOrganizationIds(filteredCompanyListIds))
  }

  return (
    <Table
      ids={ids}
      getDataFromRedux={selectTableItem}
      isLoading={isLoading}
      isNoDataWithHead={true}
      schema={tableHeader.map((item, index) => {
        if (index === 0) {
          return {
            ...item,
            render: (val) =>
              val?.toString() !== organizationId && (
                <CheckboxCellTable
                  val={val}
                  colors={colors}
                  setColors={setColors}
                  selectListChart={selectShowListChart}
                  changeListChart={changeListChart}
                />
              ),
          }
        }

        if (index === 1) {
          return {
            ...item,
            isI18n: true,
            render: (val, { rowId }) => (
              <div className="dFlex alignItemsCenter justifyContentBetween">
                <CustomLink
                  target="_blank"
                  to={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${rowId}`}
                >
                  <TextEllipsisStaticLine
                    text={val}
                    isI18n={false}
                    lineClamp={1}
                    appendStyle={{ color: '#2C73E8', cursor: 'pointer' }}
                  />
                </CustomLink>
                {rowId?.toString() !== organizationId && (
                  <Icon
                    className="icon-delete"
                    onClick={onRemoveCompany(rowId)}
                    style={{
                      color: '#9C9C9C',
                      cursor: 'pointer',
                      paddingLeft: 8,
                    }}
                  />
                )}
              </div>
            ),
          }
        }

        return {
          ...item,
          render: (val) => <ValueCell val={val} />,
        }
      })}
    />
  )
}
